// src/native/day-counter-sync.ts
import { DayCounter } from './day-counter-bridge';

const isNative =
  typeof window !== 'undefined' &&
  (window as any).Capacitor &&
  (window as any).Capacitor.isNativePlatform;

/**
 * Ensure the App Group stamp exists in shared UserDefaults.
 * Safe to call on web – it no-ops when not native.
 */
export async function ensureAppGroupStamp() {
  if (!isNative) return;
  try {
    await DayCounter.ensureInstallTs();
  } catch (e) {
    console.warn('[Trauvo] ensureInstallTs skipped/failed:', e);
  }
}

/**
 * Optionally refresh the DayCounter widget timelines on iOS.
 * Uses reloadDayCounterWidget if available, falls back to reloadAllWidgets.
 */
export async function reloadDayCounterWidgets() {
  if (!isNative) return;
  try {
    // Some runtimes still prefer hitting the raw Capacitor proxy
    const plugins = (window as any).Capacitor?.Plugins || {};
    const nativeDayCounter =
      plugins.DayCounter ?? DayCounter;

    if (nativeDayCounter?.reloadDayCounterWidget) {
      await nativeDayCounter.reloadDayCounterWidget();
    } else if (nativeDayCounter?.reloadAllWidgets) {
      await nativeDayCounter.reloadAllWidgets();
    }
  } catch (e) {
    console.warn('[Trauvo] DayCounter widget reload failed:', e);
  }
}

/**
 * Wire the in-app banner and keep the native widget in sync.
 */
export async function wireDayCounter(selector = '#day-banner-message') {
  try {
    await ensureAppGroupStamp();

    // your existing helper – assumed to be defined/imported elsewhere
    const text = await getDayString();

    const el = document.querySelector(selector);
    if (el) (el as HTMLElement).textContent = text;

    // Also nudge the widget on native so it reflects the latest streak
    await reloadDayCounterWidgets();
  } catch (err) {
    console.warn('[Trauvo] DayCounter wire failed:', err);
  }
}